$(".a-item").click(function (e) {
  // alert($(this).attr("id"));
})

$(".mobile-more-info").click(function (e) {
  var url = "https://awards.sirui.com/index/index/get_product_info.html?shopify_product_id="+$(this).parent().parent().parent().parent().parent().attr("id");
  let _this = $(this)
  $.get(url,function(data){
    var res = $.parseJSON(data);
    let info = res["info"];
    for(let i in info) {
      _this.parent().parent().parent().parent().parent().find(".more-info").find("."+i).html(info[i]);
    }
  });
  
    let money = _this.parent().parent().parent().parent().find(".jia-ge").find(".price-box").find(".transcy-money").text();
    let title = _this.parent().parent().parent().parent().find(".title").find("h3").text();
    let content = _this.parent().parent().parent().parent().find(".product-description").text();
    _this.parent().parent().parent().parent().parent().find(".more-info").find(".more-info-monney").find(".set-money").html(money);
    _this.parent().parent().parent().parent().parent().find(".more-info").find(".more-info-title").find(".more-info-title-content").html(content);
    _this.parent().parent().parent().parent().parent().find(".more-info").find(".more-info-title").find(".more-info-title-txt").html(title);
    _this.parent().parent().parent().parent().parent().find(".more-info").show(200);
})

$(".mobile-more-detail").click(function (e) {
  var bh_tc = $(this).parent().find(".bh-tc");
  var child_product_id = "";
  if (!bh_tc.hasClass("one")) {
    child_product_id = bh_tc.val();
  }
  var url = "https://awards.sirui.com/index/index/get_product_info.html?shopify_product_id="+$(this).parent().parent().attr("id") + "&child_product_id=" + child_product_id;
  let _this = $(this)
  $.get(url,function(data){
    var res = $.parseJSON(data);
    let info = res["info"];
    for(let i in info) {
      _this.parent().parent().find(".more-info").find("."+i).html(info[i]);
    }
  });
  $(".more-info-title-txt").html($(this).parent().find(".title").find("h3").text());
  $(".more-info-title-content").html($(this).parent().find(".product-description").text());
  let money = $(this).parent().find(".jia-ge").find(".price-box").find(".transcy-money").text();
  // $("#fix-div-contrast").html(money);
  $(this).parent().parent().find(".more-info").find(".more-info-monney").find(".set-money").html(money);
  $(this).parent().parent().find(".more-info").show(200);
})

$(".more-info-close").click(function (e) {
  $(this).parent().parent().hide(200);
})

$(".fix-div-full-screen").click(function (e) {
  $(".fix-div-full-screen").hide();
  $("#fix-div-contrast").hide();
})
let check_have_add = [];
let sku_arr = [];
$(".pc-compare-show-button").change(function (e) {
  var bh_tc = $(this).parent().find(".bh-tc");
  var child_product_id = "";
  if (!bh_tc.hasClass("one")) {
    child_product_id = bh_tc.val();
  }
  
  let _this = $(this);
  let id_str = _this.parent().find(".product-single__form").attr("id");
  let id = id_str.split('-')[1];
  let info = [];
  if ($("#checkbox-"+id).is(':checked') == false) {
    let this_check_box_model = _this.find("#checkbox-"+id).attr("model-value");
    sku_arr.splice($.inArray(this_check_box_model,sku_arr),1);
    $('.sku-change-box').html(sku_arr.join(", "));
    check_have_add.splice($.inArray(id,check_have_add),1);
    $(".contrast-add-product").find(".do-delete-"+id).remove();
    $(".contrast-add-product").find(".do-delete-"+id).remove();
    var len = $(".contrast-add-product").children().length;
    if (len >= 2) {
      // $(".can-show-contrast-txt").show();
      $(".fix-compare-bottom-box").show();
    } else {
      // $(".can-show-contrast-txt").hide();
      $(".fix-compare-bottom-box").hide();
    }
    return;
  }
  var url = "https://awards.sirui.com/index/index/get_product_info.html?shopify_product_id="+$(this).parent().parent().attr("id") + "&child_product_id=" + child_product_id;
  $.get(url,function(data){
    var res = $.parseJSON(data);
    info = res["info"];
    if(check_have_add.indexOf(id)!=-1){
      return;
    }
    check_have_add.push(id);
    var title = _this.parent().find(".title").find("h3").text();
    var img = _this.parent().parent().find(".txt-box").find(".sl-imgs").find(".img").find("img").attr("src");
    // let model = info != null && info["model"] ? info["model"] : "";
    // alert(model)
    sku_arr.push(info["model"]);
    $('.sku-change-box').html(sku_arr.join(", "));
    $(".contrast-add-product").append('<tr class="do-delete-'+id+'" check-id="'+id+'"><td><span>'+title+'</span><span class="remove_span" data-id = "'+id+'" model-value="'+info["model"]+'">Remove Product</span></td><td>'+info["model"]+'</td><td>'+info["material"]+'</td><td>'+info["compatible_head"]+'</td><td>'+info["sections"]+'</td><td>'+info["tube_dia"]+'</td><td>'+info["weight"]+'</td><td>'+info["max_load"]+'</td><td>'+info["folded_h"]+'</td><td>'+info["retracted_h"]+'</td><td>'+info["min_h"]+'</td><td>'+info["height"]+'</td><td>'+info["max_height"]+'</td><td>'+info["monopod_h"]+'</td><td>'+info["leg_angles"]+'</td><td>'+info["max_tube_dia"]+'</td><td>'+info["weight_max_load"]+'</td><td>'+info["ball_dia"]+'</td><td>'+info["colour"]+'</td><td>'+info["center_column_min_tube_dia"]+'</td><td>'+info["center_column_max_tube_dia"]+'</td><td>'+info["tilt"]+'</td></tr>')
    //<div><img src="'+img+'"></div>
    $('#checkbox-'+id).attr('model-value', info["model"]);
    var len = $(".contrast-add-product").children().length;
    if (len >= 2) {
      // $(".can-show-contrast-txt").show();
      $(".fix-compare-bottom-box").show();
    }
  });
})

$(".mobile-compare-show-button").change(function (e) {
  let _this = $(this);
  let info = [];
  let id_str = _this.parent().parent().find(".add-to-cart").attr("id");
  let id = id_str.split('-')[1];

  if ($("#mobile-checkbox-"+id).is(':checked') == false) {
    let this_check_box_model = _this.find("#mobile-checkbox-"+id).attr("model-value");
    sku_arr.splice($.inArray(this_check_box_model,sku_arr),1);
    $('.sku-change-box').html(sku_arr.join(", "));
    
    check_have_add.splice($.inArray(id,check_have_add),1);
    $(".contrast-add-product").find(".do-delete-"+id).remove();
    $(".contrast-add-product").find(".do-delete-"+id).remove();
    var len = $(".contrast-add-product").children().length;
    if (len >= 2) {
      // $(".can-show-contrast-txt").show();
      $(".fix-compare-bottom-box").show();
    } else {
      // $(".can-show-contrast-txt").hide();
      $(".fix-compare-bottom-box").hide();
    }
    return;
  }
  
  var url = "https://awards.sirui.com/index/index/get_product_info.html?shopify_product_id="+$(this).parent().parent().parent().parent().parent().attr("id");
  $.get(url,function(data){
    var res = $.parseJSON(data);
    info = res["info"];
    if(check_have_add.indexOf(id)!=-1){
      return;
    }
    check_have_add.push(id);
    var title = _this.parent().parent().parent().parent().find(".title").find("h3").text();
    var img = _this.parent().parent().parent().parent().parent().find(".txt-box").find(".sl-imgs").find(".img").find("img").attr("src");
    sku_arr.push(info["model"]);
    $('.sku-change-box').html(sku_arr.join(", "));
    $(".contrast-add-product").append('<tr class="do-delete-'+id+'" check-id="'+id+'"><td><span>'+title+'</span><span class="remove_span" data-id = "'+id+'" model-value="'+info["model"]+'">Remove Product</span></td><td>'+info["model"]+'</td><td>'+info["material"]+'</td><td>'+info["compatible_head"]+'</td><td>'+info["sections"]+'</td><td>'+info["tube_dia"]+'</td><td>'+info["weight"]+'</td><td>'+info["max_load"]+'</td><td>'+info["folded_h"]+'</td><td>'+info["retracted_h"]+'</td><td>'+info["min_h"]+'</td><td>'+info["height"]+'</td><td>'+info["max_height"]+'</td><td>'+info["monopod_h"]+'</td><td>'+info["leg_angles"]+'</td><td>'+info["max_tube_dia"]+'</td><td>'+info["weight_max_load"]+'</td><td>'+info["ball_dia"]+'</td><td>'+info["colour"]+'</td><td>'+info["center_column_min_tube_dia"]+'</td><td>'+info["center_column_max_tube_dia"]+'</td><td>'+info["tilt"]+'</td></tr>')
  
    $('#mobile-checkbox-'+id).attr('model-value', info["model"]);
    var len = $(".contrast-add-product").children().length;
    if (len >= 2) {
      // $(".can-show-contrast-txt").show();
      $(".fix-compare-bottom-box").show();
    }
  });
})

$("body").on("click",".remove_span",function(){
  let id = $(this).parent().parent().attr("check-id");
  
  let this_check_box_model = $(this).attr("model-value");
  sku_arr.splice($.inArray(this_check_box_model,sku_arr),1);
  $('.sku-change-box').html(sku_arr.join(", "));
  
  check_have_add.splice($.inArray(id,check_have_add),1);
  $(this).parent().parent().remove();
  $("#mobile-checkbox-"+id).prop("checked",false);
  $("#checkbox-"+id).prop("checked",false);
  var len = $(".contrast-add-product").children().length;
  if (len >= 2) {
    // $(".can-show-contrast-txt").show();
    $(".fix-compare-bottom-box").show();
  } else {
    // $(".can-show-contrast-txt").hide();
    $(".fix-compare-bottom-box").hide();
  }
});

$(".bh-tc").change(function(){
  var id_str = $(this).attr("id");
  var id = id_str.split('-')[1];


  let this_check_box_model = $("#checkbox-"+id).attr("model-value");
  if ($.inArray(this_check_box_model,sku_arr) != -1) {
    sku_arr.splice($.inArray(this_check_box_model,sku_arr),1);
    $('.sku-change-box').html(sku_arr.join(", "));
  }
  if ($.inArray(id,check_have_add) != -1) {
    check_have_add.splice($.inArray(id,check_have_add),1);
  }
  $(".contrast-add-product").find(".do-delete-"+id).remove();
  $(".contrast-add-product").find(".do-delete-"+id).remove();
  var len = $(".contrast-add-product").children().length;
  if (len >= 2) {
    // $(".can-show-contrast-txt").show();
    $(".fix-compare-bottom-box").show();
  } else {
    // $(".can-show-contrast-txt").hide();
    $(".fix-compare-bottom-box").hide();
  }
  
  $("#mobile-checkbox-"+id).prop("checked",false);
  $("#checkbox-"+id).prop("checked",false);
})




$(".mobile-show-compare-box").click(function (e) {
  $(".fix-div-full-screen").show();
  $("#fix-div-contrast").show();
})
$(".can-show-contrast-txt").click(function (e) {
  $(".fix-div-full-screen").show();
  $("#fix-div-contrast").show();
})
$(".mobile-show-clear-box").click(function (e) {
  check_have_add = [];
  sku_arr = [];
  $(".contrast-add-product").empty();
  // $(".can-show-contrast-txt").hide();
  $(".fix-compare-bottom-box").hide();
  
  $(".checkbox-check-change-class").prop("checked",false);
})
// $(".pc-compare-show-button").on('click','.pc-compare-show-button',function () {
//   alert(1)
//   // $(".fixed-div-contrast-content").append("<div class = "more-info-line"><span>Model</span><span></span></div>")
// });

$(".key-more").click(function(e){
    
	var obj=$(this).prev("ul");
	if(obj.hasClass("cur"))
	{
		obj.removeClass("cur");
		$(this).find("font").text("↓");
	}
	else{
		obj.addClass("cur");
		$(this).find("font").text("↑");
	}
    
    
});


$(".bh-tc").change(function(){
	var id=$(this).data("id");
	var i=$(this).find("option:selected").attr("money");
	$(".price1_"+id).find("span").text(i);
    var j=$(this).find("option:selected").attr("money");
    $(".price2_"+id).find(".transcy-money").text(j);
});


//--手机
$(".faiter").click(function(){
	$(".srb-box,.wap-tool-close").addClass("open");
	$(".wap-tool>.faiter").addClass("show-cur");
});


$(".wap-tool-close").click(function(){
	$(".srb-box,.wap-tool-close").removeClass("open");
	$(".wap-tool>.faiter").removeClass("show-cur");
});

$(".t-xs").click(function(){
	
	$(".sr-bh-list .a-item").click(function(){
		if($(".product-collection").width() <750)
		{
			var gurl_s=$(this).data("href");
			location.href=gurl_s;
		}
		
	});
});

//-------切换单位

function change_togm(i)
{
	var tocm=30.48;
	var toinch=0.0328084;//上面是长度
	
	var tokg=0.4536;
	var tolb=2.2046;
	
	
	var min=0;
	var max=0;
	var str="";
	var j=0;
	
	$(".kr-select").each(function(index,ele){
		var obj=$(ele);
		if(!obj.hasClass("head-type") )
		{
			obj.children("option").each(function(index2,ele2){
			 
			if(index2)
			{
				if(i==1)
				{
					//----切换为kg/cm
					min=Math.round($(ele2).attr("min"));
					max=Math.round($(ele2).attr("max"));
					str=obj.data("dw");
					if(obj.data("dw")=='lb')
					{
						str="kg";
						
					}else if(obj.data("dw")=='inch')
					{
						str="cm";
					}
				
					$(ele2).text(min+'-'+max+str);
					obj.prev("span").find("font").text(str);
				
				}
				else{
					//--切换为lb inch
					str=$(ele2).attr("value")+obj.data("dw");
					$(ele2).text(str);
					obj.prev("span").find("font").text(obj.data("dw"));
					
					
					
					
				}
			}
			
			
		});
		}
		
		
		
	});
}

$(".input-unit").change(function(){
	var i=$(this).val();
	change_togm(i);
	
	
});




//---------------筛选

$(".t-xs").focus(function(){
	var i=$(this).val();
	if(i==0)
	{
		$(this).val('');
	}

});

$(".t-xs").blur(function(){
	var i=$(this).val();
	if(!i)
	{
		$(this).val(0.0);
	}

});





$("#v-select").click(function(){
	
	$(".wap-tool>.faiter").removeClass("show-cur");
	//价格
    $(".srb-box,.wap-tool-close").removeClass("open");//关闭手机端 筛选
	
	$(".sr-s-box").addClass("loading");
	var min_price=$(".min-price").val()*1.0;
	var max_price=$(".max-price").val()*1.0;
	
	var min_weight=$(".weight option:selected").attr("min")*1.0;
	var max_weight=$(".weight option:selected").attr("max")*1.0;
	
	var min_h=$(".max-height option:selected").attr("min")*1.0;
	var max_h=$(".max-height option:selected").attr("max")*1.0;
	
	var min_h_min=$(".min-height option:selected").attr("min")*1.0;
	var max_h_min=$(".min-height option:selected").attr("max")*1.0;
	
	var min_load=$(".max-load option:selected").attr("min")*1.0;
	var max_load=$(".max-load option:selected").attr("max")*1.0;
	
	var h_type=$(".head-type").val();
	
	
	var data=new Array();
	var s_reg=/,/;
	$(".a-item").each(function(index,ele){
		
		data[index]={id:$(ele).attr("id"),head:$(ele).data("head"),weight:$(ele).data("weight"),min_price:$(ele).data("min-price"),max_price:$(ele).data("max-price"),max_h:$(ele).data("max-h"),min_h:$(ele).data("min-h"),max_load:$(ele).data("max-load")};
		
		if(s_reg.test(data[index]['min_price']))
		{
			data[index]['min_price']=data[index]['min_price'].replace(/,/,'');
		}
		
		if(s_reg.test(data[index]['max_price']))
		{
			data[index]['max_price']=data[index]['max_price'].replace(/,/,'');
		}
	
	});
	
	var i=0;
	$(".none-data-box").text("");
	$(".sr-bh-list .a-item").removeClass("a-none");
	
	for(i=0;i<data.length;i++)
	{
		
		if(h_type)
		{
			if(h_type!=data[i]['head'] || !data[i]['head'])
			{
				$("#"+data[i]['id']).addClass("a-none");
				continue;
			}
		}
		
		
		if(min_price>=0 && max_price>=0)
		{
			if(min_price>0)
			{
				if(data[i]['max_price']<min_price || !data[i]['max_price'])
				{
					
					$("#"+data[i]['id']).addClass("a-none");
					continue;
				}
				
			}
		
			if(max_price>0)
			{
				if(data[i]['min_price']>max_price || !data[i]['min_price'])
				{
					$("#"+data[i]['id']).addClass("a-none");
					continue;
				}
				
			}
		}
		
		//重
		if(min_weight>0)
		{
			if(data[i]['weight']<min_weight || !data[i]['weight'])
			{
				$("#"+data[i]['id']).addClass("a-none");
				continue;
			}
		
		}
		
		if(max_weight>0)
		{
			
			if(data[i]['weight']>max_weight || !data[i]['weight'])
			{
				$("#"+data[i]['id']).addClass("a-none");
				continue;
			}
		
		}
		
		//最大高度
		if(min_h>0)
		{
			
			if(data[i]['max_h']<min_h || !data[i]['max_h'])
			{
				$("#"+data[i]['id']).addClass("a-none");
				continue;
			}
		
		
		}
		
		if(max_h>0)
		{
			
			if(data[i]['max_h']>max_h || !data[i]['max_h'])
			{
				$("#"+data[i]['id']).addClass("a-none");
				continue;
			}
			
		}
		
		//-------------------最小高度
		if(min_h_min>0)
		{
			
			if(data[i]['min_h']<min_h_min || !data[i]['min_h'])
			{
				$("#"+data[i]['id']).addClass("a-none");
				continue;
			}
			
		
		}
		
		
		if(i==1)
		{
			//alert(max_h_min+','+data[i]['min_h']);
		}
		
		if(max_h_min>0)
		{
			if(data[i]['min_h']>max_h_min || !data[i]['min_h'])
			{
					
				$("#"+data[i]['id']).addClass("a-none");
				continue;
			}
			
		}
		
		//承重
		if(min_load>0)
		{
			if(data[i]['max_load']<min_load || !data[i]['max_load'])
			{
				$("#"+data[i]['id']).addClass("a-none");
				continue;
			}
			
		}
		
		//
		if(max_load>0)
		{
			
			if(data[i]['max_load']>max_load || !data[i]['max_load'])
			{
				$("#"+data[i]['id']).addClass("a-none");
				continue;
			}
			
		}
		
		
	}
	
	 
	
	
	
	if($(".a-item").length == $(".a-none").length)
	{
		$(".sr-s-box").removeClass("loading").addClass("none-data");
		$(".none-data-box").text("Not Found !");
		
	}else{
        
		 

        window.setTimeout(function(){
          $(".sr-s-box").removeClass("loading").removeClass("none-data");
        },1000);
		
	}
	
});











